'use strict';

var ManageAccessRequestsDirective = function ManageAccessRequestsDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/manage-access-requests.html'),
    controller: 'ManageAccessRequestsController',
    link: function link($scope) {
      $scope.$on('grid:icon-click', function (event, data) {
        $scope.pendingUserDetail(data);
        event.stopPropagation();
      });
    }
  };
};
ManageAccessRequestsDirective.inject = [];
module.exports = ManageAccessRequestsDirective;